import { AxiosError } from 'axios'
import { useCallback, useMemo } from 'react'
import { useMutation, UseMutationOptions } from 'react-query'
import { OAuthInteractionParams } from '../interfaces/OAuthInteractionParams'
import { OAuthErrorResponse } from '../interfaces/OAuthErrorResponse'
import { OAuthInteractionResponse } from '../interfaces/OAuthInteractionResponse'
import { useIamManagerOAuth } from '../useIamManagerOAuth'

type Response = OAuthInteractionResponse
export type UseOAuthSwitchUserOptions = UseMutationOptions<
  Response,
  AxiosError<OAuthErrorResponse>,
  OAuthInteractionParams
>

export const useOAuthSwitchUser = (options?: UseOAuthSwitchUserOptions) => {
  const { endpoint, switchUser } = useIamManagerOAuth()
  const mutationKey = useMemo(() => [endpoint, 'switchUser'], [endpoint])
  const mutationFn = useCallback(
    async (input: OAuthInteractionParams) => (await switchUser(input)).data,
    [switchUser]
  )
  return useMutation<Response, AxiosError<OAuthErrorResponse>, OAuthInteractionParams>({
    ...options,
    mutationKey,
    mutationFn,
    retry: false
  })
}
